import { render, staticRenderFns } from "./OpenPhoneVerifyModal.vue?vue&type=template&id=ddf06210&scoped=true"
import script from "./OpenPhoneVerifyModal.vue?vue&type=script&lang=js"
export * from "./OpenPhoneVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./OpenPhoneVerifyModal.vue?vue&type=style&index=0&id=ddf06210&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf06210",
  null
  
)

export default component.exports